import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import moment   from 'moment'
import {
    makeRequest,
    dispatchAction,
    displayMessage
} from 'actions';
import {Row, Col, Form, FormGroup, Checkbox, Modal, ControlLabel, FormControl, Button} from 'react-bootstrap';
import Select   from 'react-select'
import {prepareSelectOptionsList,onRowSelect,onAllRowSelect,customMultiSelect} from 'util/Utils';

import {
    FETCH_ADMIN_PALLETS,RESET_SELLERS_LIST
} from "actions/actionTypes";
import queryString from 'query-string'
import PaginationBox from'shared/PaginationBox';
import {fetchAllSellersList}  from 'shared/sharedMethods';
import AdminPalletProductToImportListTable from 'dashboard/pallets/AdminPalletProductToImportListTable';

import AdminPalletsListTable from 'dashboard/pallets/AdminPalletsListTable';
import AdminPalletsSearchBox from 'dashboard/pallets/AdminPalletsSearchBox'
import Datetime from 'react-datetime'
  import config from  '../../../config';
 import RemoveModalDialog from'shared/RemoveModalDialog';
import momentTimeZone from 'moment-timezone'

class AdminPalletsPage extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props, context) {
        super(props, context);
        this.state = {
             showModal: false,
            errors: {},
            currentPage: _.isUndefined(this.props.location.query.page) ? 0 : parseInt(this.props.location.query.page) - 1,
            sortBy: '',
            perPage: config.table.numberPerPage,
            currentRecord:{},
            productsDataFileUrl:'',
            importProductsMode:false,
            productsToImport:[],
            recordIDs:[],

        };
        this.saveRecord = _.throttle(this.saveRecord, 2000, {
            'leading': true,
            'trailing': false
        });
     };

    componentWillMount() {
        let queryParams = queryString.parse(this.props.location.search);
        console.log('queryParams', queryParams);
        let params = {
            'page': _.isUndefined(queryParams.page) || parseInt(queryParams.page) <= 1 ? 1 : parseInt(queryParams.page),
            perPage: _.isUndefined(queryParams.perPage) ? config.table.numberPerPage : parseInt(queryParams.perPage),
            sortBy: queryParams.sortBy,
            doNotUpdateUrlString: true,
        }
        this.setState({...this.state, ...params})
        if (!_.isUndefined(queryParams.searchText)) {
            params.searchText = queryParams.searchText
        }
        this.search(params)

        fetchAllSellersList.call(this)

    }

    componentWillReceiveProps(nextProps) {
        if (_.size(nextProps.allSellersList.data) !== _.size(this.props.allSellersList.data)) {
            this.setState({sellerOptionsList :prepareSelectOptionsList(nextProps.allSellersList.data, {
                label: 'DisplayName',
                value: '_id'
            })})
        }
    }
    importProductsAction(row) {
        this.setState({
            importProductsMode:true,
            currentRecord: row
        });
    }
    editRecord(row) {
        var currentRecordData =   _.extend({}, row, {
            ArrivalDateFrom:_.get(row, 'PalletCustomData.ArrivalDateFrom') ? moment(_.get(row, 'PalletCustomData.ArrivalDateFrom'))  : null,
            ArrivalDateTo:_.get(row, 'PalletCustomData.ArrivalDateTo') ? moment(_.get(row, 'PalletCustomData.ArrivalDateTo'))  : null,
            items:[],
         })
        this.setState({
            showModal: true,
            currentRecord: currentRecordData
        });
    }

    closeModal() {
        this.setState({
            showModal: false,
            currentRecord: {},
        });
    }

    showRemoveDialog(row) {
        this.setState({removeModalVisible: true, currentRecord: row});
    }


    deleteRecord() {
        this.setState({removeModalVisible: false});
        var methodData = {
            type: 'delete',
            "endpoint": "/pallets",
            messageData: {'#1#': 'Record'},
            messageCode: 'recordDeleted',
        };
        this.props.makeRequest({id: this.state.currentRecord._id}, methodData).then(res => {
            this.setState({currentRecord: {}});
            this.search()
        }).catch(err => {
            this.setState({currentRecord: {}});
            console.log('e', err);
        });

    }

    validateAndGetFormData() {
        var formData = _.pick(this.state.currentRecord, [  'Notes','Tracking','PalletNumber', 'Status'])
        if (!_.get(this.state.currentRecord, 'ArrivalDateFrom') || !_.get(this.state.currentRecord, 'ArrivalDateTo')) {
            this.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'errorFieldNotSpecified',
                messageData: {'#1#': 'expected arrival date'}
            });
            return false
        }
        if (moment(_.get(this.state.currentRecord, 'ArrivalDateFrom')).isAfter(moment(_.get(this.state.currentRecord, 'ArrivalDateTo')))) {
            this.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'Expected arrival date range is not valid',
             });
            return false
        }
        if (!this.state.currentRecord._id) {
            if (!_.get(this.state.currentRecord, 'MarketName.value')) {
                this.props.displayMessage({
                    'messageType': 'warning',
                    'messageCode': 'errorFieldNotSpecified',
                    messageData: {'#1#': 'Market Name'}
                });
                return false
            }
            // if (!_.get(this.state.currentRecord, 'PalletNumber')) {
            //     this.props.displayMessage({
            //         'messageType': 'warning',
            //         'messageCode': 'errorFieldNotSpecified',
            //         messageData: {'#1#': 'Pallet ID'}
            //     });
            //     return false
            // }
            formData.MarketName = _.get(this.state.currentRecord, 'MarketName.value')
            if (_.get(this.state.currentRecord, 'SellerID')) {
                formData.SellerID = _.get(this.state.currentRecord, 'SellerID')
            }
        }

        var  timeZoneName = _.get(_.find(config.warehouseData, {MarketName: _.get(this.state.currentRecord, 'MarketName.value', 'Denver')}), 'timeZoneName')
console.log('timeZoneName', timeZoneName  );

        formData.PalletCustomData = {
            ArrivalDateFrom:momentTimeZone(_.get(this.state.currentRecord, 'ArrivalDateFrom')).tz(timeZoneName).set({
                'hour': 12,
                'minute': 0,
                millisecond: 0
            }),

            ArrivalDateTo:momentTimeZone(_.get(this.state.currentRecord, 'ArrivalDateTo')).tz(timeZoneName).set({
                'hour': 12,
                'minute': 0,
                millisecond: 0
            }),
        }


        // formData.PalletProducts =_.map(_.range(1,2), (number)=>{
        // return    {
        //    Description:'Description' + number,
        //     ProductName:'Product name' + number,
        //     COGS:number,
        //     Quantity:1,
        //     ProductNumber:number,
        //     }
        // })
        return formData
    }
    addNewRecord() {
        this.props.dispatchAction({}, RESET_SELLERS_LIST)
        setTimeout( ()=> {
            fetchAllSellersList.call(this)
        },500)

        this.setState({
            showModal: true,
            currentRecord: {
                Notes: '',
                MarketName:{value:'Denver', 'label':'Denver'},
                Items:[],
            },

        });
    }
    saveRecord() {

        var self = this;
        this.setState({pending: true});
        var formData = this.validateAndGetFormData();
        if (!formData) {
            this.setState({pending: false});
            return false;
        }
        if (this.state.currentRecord._id) {
            var methodData = {
                "endpoint": "/pallets" + '/' + encodeURIComponent(this.state.currentRecord._id),
                type: "patch",
                messageData: {'#1#': 'Pallet'},
                messageCode: 'recordUpdated',
            };
        } else{
            var methodData = {
                "endpoint": "/pallets",
                type: "post",
                messageData: {'#1#': 'Pallet'},
                messageCode: 'recordAdded',
            };
        }
        self.props.makeRequest(formData, methodData).then(recordUpdateResponse => {
            self.setState({pending: false});

            self.search({page:self.state.currentPage+1})
            self.closeModal()
        }).catch(err => {
            self.setState({pending: false});
        });
    }

    getOrImportProductsForPallet(params){
        var self = this;
        this.setState({pending: true});
        var methodData = {
            "endpoint": "/pallets" + '/' + encodeURIComponent(this.state.currentRecord._id)+'/'+params.action,
            type: "patch",
          };

        self.props.makeRequest(params, methodData).then(resp => {
            if (params.action =='get-products-to-import'){
                var productsToImport = _.get(resp.data,'productsToImport',[])
                self.setState({
                    pending: false,
                     productsToImport:productsToImport,

                })
                setTimeout(function () {
                    self.setState({
                        recordIDs:_.map(self.state.productsToImport, '_id')

                    })
                }, 500)
            }else {
                self.props.displayMessage({
                    'messageCode': _.get(resp, 'data.NumberOfSavedProducts') + (_.get(resp, 'data.NumberOfSavedProducts') == 1 ? ' product' : ' products') + ' imported',
                });
                self.setState({
                    pending: false,
                 });
                this.search()
            }

        }).catch(err => {
            self.setState({pending: false});
        });
    }

    onSortChange(field, sortPallet) {
        console.log('field', field);
        this.setState({sortBy: field + ':' + (sortPallet == 'asc' ? 1 : -1)}, function () {
            this.refs.pagination.resetPagination();
            this.search()
        })
    }

    search(params = {}) {
        if (this.state.pending){
            return this.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'Please wait till search request is completed'
            });
        }
        this.setState({pending:true})
        if (this.refs.searchBox) {
            var {queryParams} = this.refs.searchBox.getSearchParams();
        } else {
            var queryParams = {}
        }
        _.extend(queryParams, params);


        if (this.state.sortBy) {
            queryParams.sortBy = this.state.sortBy;
        } else {
            queryParams.sortBy = 'PickupNumber' + ':' + (-1);
        }

        queryParams.sortBySecondary = '_id:-1';
        /* without secondary sort query, the pallet of documents with the same fields is not guaranteed across pages */
         var methodData = {
            "endpoint": "/pallets",
            'not_display_success_message': true,
            'success_event': FETCH_ADMIN_PALLETS
        };

        if (_.isUndefined(params.doNotUpdateUrlString)) {
            const stringified = queryString.stringify(_.omit(queryParams, ['include', 'lookup', 'all','sortBySecondary']));
            this.context.router.push('/admin/pallets?' + stringified);
        }
        queryParams.lookup = ['PalletProductsNumber', 'SellerID' ]

        return this.props.makeRequest(queryParams, methodData).then(res => {
            this.setState({pending:false})
            if (this.refs.pagination && _.isUndefined(queryParams.page)) {
                console.log('before reset pagination');
                this.refs.pagination.resetPagination();
            }
        }).catch(err => {
            this.setState({pending:false})
        });
    }


    render() {


         return (
            <div >
                <AdminPalletsSearchBox pending={this.state.pending}
                                       ref="searchBox"
                    addNewRecord={this.addNewRecord.bind(this)}
                    search={this.search.bind(this)}
                    {...this.props} ></AdminPalletsSearchBox>
                {this.props.adminPallets.fetched &&
                <div>
                    {this.props.adminPallets.total == 0 ?
                        <div
                            className="messageBox">{config.clientMessages.noRecordsFoundForCriteria.replace("#1#", 'records')}</div> :
                        <div className=" ">
                            {this.state.importProductsMode &&
                            <div className=" ">

                                <div>
                                    <ControlLabel>Google sheet file url</ControlLabel>
                                    <FormControl type="text"

                                                 onChange={(e) =>{

                                                     this.setState({
                                                         'productsDataFileUrl': e.target.value
                                                     } )

                                                 }}
                                                 value={this.state.productsDataFileUrl }
                                                 placeholder=""/>
                                </div>

                                <div className="top15 bot15">

                                    <Button className=" left20 pull-right btn btn-primary  "
                                            disabled={!this.state.recordIDs.length || this.state.pending}
                                            type="button"
                                            onClick={() => {
                                                if (this.state.productsToImport.length >0) {
                                                    var productsToImport = _.filter(this.state.productsToImport, (item) => {
                                                        return _.includes(this.state.recordIDs, item._id)
                                                    })
                                                    var notValidProduct = _.find(productsToImport, product=> {
                                                        console.log('product', product.PalletProductData);
                                                        if (!_.get(product, 'PalletProductData.Quantity') || !_.get(product, 'PalletProductData.WhatWePaidToUnit') || !_.get(product, 'PalletProductData.RetailToUnit')) {
                                                            return true
                                                        }
                                                    })

                                                    if (notValidProduct){
                                                      return  this.props.displayMessage({
                                                            'messageType': 'warning',
                                                            'messageCode': 'Product ' + notValidProduct.ProductName +' does not include all required fields: What We Paid To Unit, Quantity, Retail To Unit',
                                                            messageData: {'#1#': 'expected arrival date'}
                                                        });
                                                    }

                                                    this.getOrImportProductsForPallet({action: 'import-products',productsToImport:productsToImport})
                                                }
                                            } }>
                                        {  'Import selected products'}
                                    </Button>
                                    <Button className=" left20 pull-right btn btn-primary  "
                                            disabled={!_.includes(this.state.productsDataFileUrl,'docs.google.com/spreadsheets') || this.state.pending}
                                            type="button"
                                            onClick={() => {
                                                this.getOrImportProductsForPallet({productsDataFileUrl:this.state.productsDataFileUrl, action: 'get-products-to-import'})
                                            } }>
                                        {'Display products to import'}
                                    </Button>
                                    <Button className=" right20 pull-right btn btn-default  "
                                            type="button"
                                            onClick={() => {
                                                this.setState({
                                                    importProductsMode:false,
                                                   recordIDs:[],
                                                    productsToImport:[],
                                                    productsDataFileUrl:'',
                                                });
                                            } }>
                                        Cancel
                                    </Button>
                                    <div className="clearfix"></div>
                                </div>
                                {this.state.productsToImport.length > 0 &&
                                <div style={{marginBottom:60}}  >
                                     <ControlLabel>{this.state.productsToImport.length + ' ' +(this.state.productsToImport.length == 1 ? 'product': 'products') + ' to import'}</ControlLabel>
                                    <AdminPalletProductToImportListTable
                                        ref='table'
                                        data={this.state.productsToImport}
                                        onRowSelect ={onRowSelect.bind(this)}
                                        onAllRowSelect ={onAllRowSelect.bind(this)}
                                        customMultiSelect ={customMultiSelect.bind(this)}
                                      {...this.props}   ></AdminPalletProductToImportListTable>
                                </div>
                                }
                            </div>
                            }
                            <AdminPalletsListTable
                                 onSortChange={this.onSortChange.bind(this)}
                                showRemoveDialog={this.showRemoveDialog.bind(this)}
                                editRecord={this.editRecord.bind(this)}
                                importProductsAction={this.importProductsAction.bind(this)}
                                search={this.search.bind(this)} {...this.props}  ></AdminPalletsListTable>
                            <PaginationBox
                                currentPage={_.isUndefined(queryString.parse(this.props.location.search).page) ? 0 : parseInt(queryString.parse(this.props.location.search).page) - 1}
                                perPage={this.refs.searchBox ? this.refs.searchBox.state.filterOptions.perPage : _.get(queryString.parse(this.props.location.search), ['perPage'], undefined)}
                                ref={'pagination'}
                                total={this.props.adminPallets.total == 'initial' ? 0 : this.props.adminPallets.total}
                                search={this.search.bind(this)}>
                            </PaginationBox>

                        </div>}
                </div>
                }

                <Modal onExited={this.closeModal.bind(this)} show={this.state.showModal}
                       onHide={(e) => this.setState({showModal: false})}>
                    <Modal.Header closeButton>
                        <Modal.Title>{this.state.currentRecord._id ? 'Edit' : 'Add new'}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form  >
                            <FormGroup>
                                <ControlLabel>Status</ControlLabel>
                                <Select
                                    tabIndex="0"
                                    clearable={false}
                                    placeholder=""
                                    options={  [
                                        {value: 'Incoming', label: 'Incoming'},
                                        {value: 'In Progress', label: 'In Progress'},
                                         {value: 'Checked', label: 'Checked'},
                                    ]}
                                    onChange={(option) => this.setState({
                                        'currentRecord': {
                                            ...this.state.currentRecord,
                                            Status: option.value
                                        }
                                    })}
                                    value={  _.get(this.state.currentRecord, 'Status')}
                                />
                            </FormGroup>
                            <FormGroup>
                                <ControlLabel>Seller</ControlLabel>
                                {this.state.currentRecord._id ?
                                    <div>{_.get(this.state.currentRecord, 'SellerID.DisplayName') }</div> :
                                    <Select
                                        tabIndex="0"
                                        searchable={true}
                                        selectedOptions
                                        clearable={true}
                                        placeholder=""
                                        options={this.state.sellerOptionsList}
                                        // options={ this.props.foundSellersList }
                                        onChange={ (selectedOption) => {
                                            console.log('selectedOption', selectedOption);

                                            this.setState({
                                                'currentRecord': {
                                                    ...this.state.currentRecord,
                                                    SellerID: selectedOption ? selectedOption.value : null,
                                                }
                                            })
                                        }}
                                        value={this.state.currentRecord.SellerID}
                                    />
                                }
                            </FormGroup>

                             <FormGroup>
                                <ControlLabel>Market</ControlLabel>
                                 {this.state.currentRecord._id ?
                                     <div>{_.get(this.state.currentRecord, 'MarketName') }</div> :
                                     <Select
                                         tabIndex="0"
                                         searchable={false}
                                         selectedOptions
                                         clearable={false}
                                         placeholder="Market Name"
                                         options={ config.marketsList}
                                         onChange={(selectedOption) => {
                                             this.setState({
                                                 'currentRecord': {
                                                     ...this.state.currentRecord,
                                                     MarketName: selectedOption
                                                 }
                                             })
                                         }}
                                         value={this.state.currentRecord.MarketName }
                                     />
                                 }
                            </FormGroup>
                            <FormGroup>
                                <ControlLabel>Pallet Number</ControlLabel>
                                <FormControl type="text"
                                             onChange={(e) => this.setState({
                                                 'currentRecord': {
                                                     ...this.state.currentRecord,
                                                     PalletNumber: e.target.value
                                                 }
                                             })}

                                             value={this.state.currentRecord.PalletNumber }
                                             placeholder=""/>
                            </FormGroup>
                            <FormGroup>
                                <ControlLabel>Internal Note (name of source)</ControlLabel>
                                <FormControl type="text"
                                             componentClass="textarea"
                                             onChange={(e) => this.setState({
                                                 'currentRecord': {
                                                     ...this.state.currentRecord,
                                                     Notes: e.target.value
                                                 }
                                             })}

                                             value={this.state.currentRecord.Notes }
                                             placeholder=""/>
                            </FormGroup>
                            <FormGroup>
                                <ControlLabel> Expected arrival date range:</ControlLabel>
                                <Datetime

                                    isValidDate={  (date) => {
                                        if (moment(date).isBefore(moment(), 'day')) {
                                            return false;
                                        }
                                        return true
                                    }}
                                    closeOnSelect={true}
                                    dateFormat={'MM-DD-YYYY'}
                                    timeFormat={false}
                                    onChange={(option) => {
                                        var d = moment(option, 'D/M/YYYY');
                                        if (d == null || !d.isValid()) {
                                                   return false;
                                        }

                                        this.setState({
                                            'currentRecord': {
                                                ...this.state.currentRecord,
                                                ArrivalDateFrom: option
                                            }
                                        })
                                    }
                                    }
                                    inputProps={{
                                        placeholder:  'To',
                                        style:{maxWidth:300}
                                    }}
                                    value={this.state.currentRecord.ArrivalDateFrom}
                                 />
                                    <Datetime

                                        isValidDate={  (date) => {
                                            if (moment(date).isBefore(moment(), 'day')) {
                                                return false;
                                            }
                                            return true
                                        }}
                                        closeOnSelect={true}
                                        dateFormat={'MM-DD-YYYY'}
                                        timeFormat={false}
                                        onChange={(option) => {
                                            var d = moment(option, 'D/M/YYYY');

                                            if (d == null || !d.isValid()) {
                                                return false;
                                            }
                                            this.setState({
                                                'currentRecord': {
                                                    ...this.state.currentRecord,
                                                    ArrivalDateTo: option
                                                }
                                            })
                                        }
                                        }
                                        inputProps={{
                                            placeholder:  'From',
                                            style:{marginTop:20, maxWidth:300}
                                        }}
                                        value={this.state.currentRecord.ArrivalDateTo}
                                    />

                            </FormGroup>
                            <FormGroup>
                                <ControlLabel>Tracking number (if available)</ControlLabel>
                                <FormControl type="text"
                                             componentClass="textarea"
                                             onChange={(e) => this.setState({
                                                 'currentRecord': {
                                                     ...this.state.currentRecord,
                                                     Tracking: e.target.value
                                                 }
                                             })}

                                             value={this.state.currentRecord.Tracking }
                                             placeholder=""/>
                            </FormGroup>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer className="">
                        <Row className="left0">
                            <Col md={12} sm={12} xs={12} className="pleft0">
                                <Button className=" right0 pull-right btn btn-primary " type="button"
                                        onClick={()=>{
                                            if (!this.state.pending) {
                                                this.saveRecord()
                                            }

                                        } }>
                                    {this.state.currentRecord._id ? 'Update':'Save'}
                                </Button>
                                <Button className="pull-right btn right20 btn-default" type="button"
                                        onClick={(e) => this.closeModal() }>
                                    Cancel
                                </Button>
                            </Col>
                        </Row>
                    </Modal.Footer>
                </Modal>

                <RemoveModalDialog
                    show={this.state.removeModalVisible}
                    removeRecord={(e) => this.deleteRecord() }
                    closeModal={(e) => this.setState({currentRecord: false, removeModalVisible: false})}>
                </RemoveModalDialog>
            </div >
        );

    }
}

function mapStateToProps(state, props) {
    return {
        userReducer: state.userReducer,
        adminPallets:state.adminPallets,
        allSellersList: state.allSellersList
     };
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators({makeRequest, dispatchAction, displayMessage}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminPalletsPage);
